export default {
    data() {
        return {
            waitTime: 0,
        }
    },
    computed: {
        isWaiting() {
            return this.waitTime > 0;
        },
    },
    methods: {
        addWaitTask() {
            const me = this;
            me.waitTime = 60;
            me.waitTask = setInterval(function () {
                me.waitTime--;
                if (me.waitTime <= 0) {
                    me.clearWaitTask();
                }
            }, 1000);
        },
        clearWaitTask() {
            const me = this;
            if (me.waitTask) {
                clearInterval(me.waitTask);
            }
            me.waitTime = 0;
        },
    }
}